<script lang="ts" setup>
import { computed } from 'vue'

import { classMerge } from '@toni/brand-ui'

import { usePageStore } from '../../stores/page'
import { usePageBlockWidth } from '../../composables/use-page-block-width.ts'
import { useContentBlock } from '../../content-blocks/composables/use-content-block'
import { toValidHTML } from '../../utils/html-utils'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'text')

const pageStore = usePageStore()
const adaAutoNative = computed(() => pageStore.pageData?.metaData?.adaAutoNative as boolean)

const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)
</script>

<template>
  <div :data-ems="adaAutoNative ? 'ems-native-articletext' : null"
       :class="classMerge('blockText prose pb-6 md:pb-8 font-body text-foreground text-body-md max-w-full sm:text-body-lg prose-a:text-secondary-500 hover:prose-a:text-primary-350 prose-a:decoration-from-font prose-a:underline-offset-2 prose-li:m-0 prose-li:leading-7 prose-li:ps-0 sm:prose-li:leading-8 prose-li:marker:text-foreground [&_u]:decoration-from-font [&_u]:underline-offset-2 [&_li_p]:m-0', {
         'mx-0 w-full max-w-none': size === 'full',
         'w-full md:max-w-[640px] lg:max-w-[764px] mx-auto': size === 'normal'
       })"
       v-html="toValidHTML(contentBlock.data.text)" />
</template>
